import React from "react"
import Layout from "../../components/Layout"
import SEO from "../../components/Seo"
import Banner from "../../components/IELTS_Academic/Banner"
import Menu from "../../components/IELTS_Academic/Menu"
import RecomendedCourses from "../../components/IELTS_Academic/RecomendedCourses"
import WritingModule from "../../components/IELTS_Academic/WritingModule"

const Writing = () => (
  <Layout>
    <SEO title="IELTS Academic - Writing" />
    <main>
        <Banner />
        <Menu />
        <WritingModule />
        <RecomendedCourses />
    </main>
  </Layout>
)

export default Writing
